import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/footer.css"; // Make sure to create and import this CSS file
import logo from "./styles/images/footerlogo.jpg"; // Update the path accordingly
import dark_logo from './styles/images/mainlogo-black.png';
import { Navigate, useNavigate } from "react-router-dom";
import { useAuths } from "../context/AuthProviders";

const Footer = () => {
  const { user, loading, isAuthenticated } = useAuths();
  const navigate = useNavigate();
  const handleReviewClick = () => {
    if (!isAuthenticated) {
      window.location.href = '/review';
      return;
    }
    const userRole = user?.profile?.user_type || user?.user_type;
    
    if (userRole === 'admin' || userRole === 'hr') {
      window.location.href = '/hr/dashboard';
    } else {
      window.location.href = '/apply-hr';
    }
  };
  const handleHRLoginClick = () => {
    window.location.href = '/login?redirect=/hr/dashboard';
  };
  const getUserRole = () => {
    if (!isAuthenticated) return null;
    return user?.profile?.user_type || user?.user_type;
  };

  const userRole = getUserRole();

  return (
    <section id="footer">
      <div className="container-fluid">
        <div className="">
          <div className="row mb-5 border-bottom p-3">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3>Add a review</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-right" align="right">
              <div className="d-flex justify-content-end gap-2">
                {!isAuthenticated ? (
                  <>
                    <button onClick={handleReviewClick} className="nav0cta me-2">
                      Review
                    </button>
                    <button onClick={handleHRLoginClick} className="nav0cta" style={{ backgroundColor: '#6c757d' }}>
                      <i className="fas fa-user-tie me-1"></i> HR Login
                    </button>
                  </>
                ) : (
                  <button onClick={handleReviewClick} className="nav0cta">
                    {userRole === 'admin' || userRole === 'hr' ? (
                      <>
                        <i className="fas fa-tachometer-alt me-1"></i> HR Dashboard
                      </>
                    ) : (
                      <>
                        <i className="fas fa-user-plus me-1"></i> Apply for HR
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>

         
          <div className="row mb-4">
            {/* Company Information Section */}
            <div className="col-lg-4 col-md-12 col-sm-12" id="footer-col1">
              <img
                src={dark_logo}
                alt="Company Logo"
                width="300px"
                height="120px"
                className="mb-2"
              />
              <h2 className="font-weight-bold my-3">Samah Home Care</h2>
              <p><i className="fas fa-map-marker-alt me-2"></i> Address:330 SW 4th Street, Suite 9-B, Willmar, MN 56201</p>
              <p>
                <i className="fas fa-phone me-2"></i> Office: <a href="tel:320-455-2702" target="_blank" rel="noopener noreferrer">320-455-2702</a>
              </p>
              <p>
                <i className="fas fa-fax me-2"></i> Fax: <a href="tel:320-272-2915" target="_blank" rel="noopener noreferrer">320-272-2915</a>
              </p>
              <p>
                <i className="fas fa-envelope me-2"></i> <a href="mailto:info@samahcare.com" target="_blank" rel="noopener noreferrer">info@samahcare.com</a>
              </p>

              {/* Social Media Links */}
              <div className="Footer-links">
                <p>
                  <i className="fab fa-facebook me-2" onClick={()=> {
                    window.location.href = 'https://www.facebook.com/SamahHomeHealthCare#';
                  }}></i>
                </p>
                <p>
                  <i className="fab fa-x-twitter me-2" onClick={()=> {
                    window.location.href = 'https://www.facebook.com/SamahHomeHealthCare#';
                  }} ></i>
                </p>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="col-lg-4 col-md-4 col-sm-6 Quick-links">
              <div className="links-links">
                <h5 className="heading">Quick Links</h5>
                <ul>
                  <li> <a href="/" className="nav-link"> Home</a></li>
                  <li> <a href="/why-samah-homes"> About Us </a></li>
                  <li> <a href="/service"> Our Services </a> </li>
                  <li> <a href="/covid-19"> Covid-19 </a> </li>
                  <li> <a href="/contact-us"> Contact Us </a> </li>
                  <li> <a href="/Resource/evv"> EVV </a> </li>
                </ul>
              </div>

              <br />
              <div className="links-links">
                <h5 className="heading">Employee</h5>
                <ul>
                  <li> 
                    {isAuthenticated && (userRole === 'admin' || userRole === 'hr') ? (
                      <a href="/hr/form">Employee Form (HR)</a>
                    ) : (
                      <a href="/career">Employee Form</a>
                    )}
                  </li>
                </ul>
              </div>
            </div>

            {/* Resources Section */}
            <div className="col-lg-4 col-md-4 col-sm-6 Quick-links">
              <h5 className="heading">Resources</h5>
              <ul>
                <li><a href="http://www.caregiving.com/" target="_blank">Caregiving – Insights, Information, Inspirations</a></li>
                <li><a href="http://www.hcaoa.org/" target="_blank">Home Care Association of America</a></li>
                <li><a href="http://www.jointcommission.org/" target="_blank">Joint Commission on Accreditation of Healthcare Organizations</a></li>
                <li><a href="http://www.nahc.org/" target="_blank">National Association for Home Care and Hospice</a></li>
                <li><a href="http://www.health.nih.gov/" target="_blank">National Institutes of Health</a></li>
                <li><a href="https://www.mesotheliomaguide.com/mesothelioma/" target="_blank">Mesothelioma Guide</a></li>
                <li><a href="https://www.therecoveryvillage.com/" target="_blank">Drug and Alcohol Treatment Resources for the Elderly</a></li>
              </ul>
              
              <h5 className="heading">Client</h5>
              <ul>
                <li onClick={() => {
                  window.location.href = '/contact-us#Contactform'
                }} style={{ cursor: 'pointer' }}>Client Form</li>
                <li> <a href="https://calendly.com/samahhomeh/30min?month=2025-03"> Schedule an Appointment</a></li>
              </ul>

              {/* Admin/HR Quick Access */}
              {isAuthenticated && (userRole === 'admin' || userRole === 'hr') && (
                <>
                  <h5 className="heading mt-3">HR Portal</h5>
                  <ul>
                    <li><a href="/hr/dashboard">Dashboard</a></li>
                    <li><a href="/hr/form">View Forms</a></li>
                  </ul>
                </>
              )}

              {/* HR Login Link for non-authenticated users */}
              {!isAuthenticated && (
                <>
                  <h5 className="heading mt-3">HR Access</h5>
                  <ul>
                    <li>
                      <a href="/login?redirect=/hr/dashboard" style={{ color: '#ffc107' }}>
                        <i className="fas fa-sign-in-alt me-1"></i> HR Login
                      </a>
                    </li>
                    <li>
                      <a href="/apply-hr" style={{ color: '#17a2b8' }}>
                        <i className="fas fa-user-plus me-1"></i> Apply for HR
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>

          <div className="divider mb-4 border-top"></div>

          {/* Copyright and Policies Section */}
          <div className="row" style={{ fontSize: "12px" }}>
            <div className="col-md-6">
              <p>
                <a href="https://triodevelopers.com/" style={{listStyle: "none", color: "white"}}>
                  <i className="fa fa-copyright"></i> {new Date().getFullYear()} Samah Home Care || Powered By TrioDevelopers, All Rights Reserved.
                </a>
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-end policy">
              <div>Terms of Use</div>
              <div>Privacy Policy</div>
              <div>Cookie Policy</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;